<template>
  <div class="ts-app-shell_fh">
    <div class="padd-main">
      <div style="margin-top: 20px">
        <el-col :xl="16" :lg="16" :md="16" :sm="24" :xs="24">
          <h5>
            <strong class="mobile-menu">
              Search Jobs
              <i
                class="fas fa-reply"
                @click="backToOrigin"
                style="font-size: 24px; margin-right: 20px; float: right"
              ></i>
            </strong>
          </h5>
        </el-col>
        <el-col :xl="8" :lg="8" :md="8" :sm="24" :xs="24">
          <div class="ts-app-shell--header_actions" style="float: right">
            <button class="ts-btn ts-btn-small" @click="backToOrigin">
              Back
            </button>
          </div>
        </el-col>
      </div>
      <span style="font-size: 15px">
        <strong>Know the job you are looking for?</strong> <br />Here you can
        identify job specific you wanted to work or search for your target
        institution's job vacancy and apply for them. </span
      ><br /><br /><br /><br />
      <el-row container>
        <el-col :xl="8" :lg="8" :md="12" :sm="24" :xs="24">
          <p>Search For</p>
          <el-select
            v-model="searchtype"
            style="width: 300px"
            placeholder="Select Employees"
          >
            <el-option
              style="width: 300px"
              v-for="item in searchlist"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :xl="8" :lg="8" :md="12" :sm="24" :xs="24">
          <p>&nbsp;</p>
          <el-input
            maxlength="100"
            type="text"
            style="width: 300px"
            v-model="keyword"
            :placeholder="searchPlaceholder + '..'"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="search"
            ></el-button>
          </el-input>
        </el-col> </el-row
      ><br /><br />
      <el-row container>
        <div
          :xl="24"
          :lg="24"
          :md="24"
          :sm="24"
          :xs="24"
          class="ts-matches"
          v-if="matches != 0"
          style="height: 505px; width: 100%; overflow-y: scroll"
        >
          <div
            class="ts-matches--match"
            v-for="(match, index) in matches"
            :key="index"
            :class="{ 'top-match': index == 0 }"
          >
            <span class="ts-matches--match_topmatch" v-if="index == 0">
              <v-icon name="crown" /> Best Match <i></i>
            </span>
            <div class="ts-matches--match_top">
              <div class="ts-matches--match_info">
                <span v-if="match.image !== 'na'" class="match_image">
                  <img :src="match.image" :alt="match.name" />
                </span>
                <span v-if="match.image === 'na'" class="match_image">
                  <img
                    v-bind:src="
                      'https://ui-avatars.com/api/?name=' +
                        `${match.companyName}` +
                        '&background=14223C&color=fff'
                    "
                    :alt="match.Name"
                  />
                </span>
                <div class="role-position-container-mid">
                  <div class="match_title">
                    {{ match.fullSGA.sgaEmployeeInfo.employeeRoleTitle }}
                  </div>
                  <div class="match_department">
                    {{ match.companyName }}
                  </div>
                </div>
              </div>
              <div class="ts-matches--match_actions">
                <button class="ts-btn ts-btn-small" @click="viewRole(match)">
                  View Role
                </button>
                <button
                  class="ts-btn ts-btn-small"
                  disabled
                  v-if="
                    match.invitation != null &&
                      match.invitation != undefined &&
                      match.invitation === 'INPROGRESS'
                  "
                >
                  * In progress!
                </button>
                <button
                  class="ts-btn ts-btn-small ts-btn-outline"
                  @click="applyForRole(match, $event, index)"
                  v-if="
                    match.invitation == undefined || match.invitation === 'NONE'
                  "
                >
                  Apply for Role
                </button>
              </div>
              <el-dropdown
                class="ts-matches--match_actions_mobile"
                trigger="click"
                style="display: none"
              >
                <i
                  class="fas fa-ellipsis-v"
                  style="font-size: 24px; margin-left: 20px"
                ></i>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="el-dropdown-menu__item"
                    ><span @click="viewRole(match)"
                      >View Role</span
                    ></el-dropdown-item
                  >
                  <el-dropdown-item class="el-dropdown-menu__item"
                    ><span
                      disabled
                      v-if="match.invitation === 'INPROGRESS'"
                      style="color: #b7b3b3"
                      >* In Progress!
                    </span></el-dropdown-item
                  >
                  <el-dropdown-item class="el-dropdown-menu__item"
                    ><span
                      @click="applyForRole(match, $event)"
                      v-if="match.invitation === 'NONE'"
                      >Apply for Role
                    </span></el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </div>
            <div class="ts-matches--match_bottom">
              <div class="match_percent">
                <el-progress
                  type="circle"
                  :width="50"
                  :stroke-width="4"
                  color="#14223C"
                  :percentage="Math.round(match.percentMatch)"
                ></el-progress>
              </div>
              <!-- <div class="match_upskilling" v-if="match.PercentMatch === '0.00'">
                            <span>Please complete your profile to see if your skills match this role.</span>
                        </div> -->
              <!-- <div class="match_upskilling" v-if="match.PercentMatch !== '0.00'"> -->
              <div class="match_upskilling">
                <strong>Recommended Upskilling</strong>
                <ul>
                  <li
                    v-for="(skill, index) in match.upSkillingRequired"
                    :key="index"
                  >
                    <span>{{ skill.selection }}</span>
                    <span v-if="index + 1 != match.upSkillingRequired.length"
                      >,</span
                    >
                  </li>
                </ul>
              </div>
            </div>
            <el-row :gutter="12" style="padding-left: 30px">
              <el-col :lg="2" :xl="1" :sm="6" :xs="6">
                <span
                  v-if="
                    parseInt(match.fullSGA.sgaEmployeeInfo.employmentType) ===
                      TypeOfRoleContract.permanent
                  "
                  class="permanent-role-type"
                >
                  Permanent</span
                >
                <span
                  v-else-if="
                    parseInt(match.fullSGA.sgaEmployeeInfo.employmentType) ===
                      TypeOfRoleContract.temporary
                  "
                  class="permanent-role-type"
                >
                  Temporary</span
                >
                <span v-else class="temporary-role-type"> Not Set</span>
              </el-col>
              <el-col :lg="2" :xl="1" :sm="6" :xs="6">
                <span
                  v-if="
                    parseInt(match.fullSGA.sgaEmployeeInfo.roleContract) ===
                      TypeOfRoleContract.fullTime
                  "
                  class="permanent-role-type"
                >
                  FullTime</span
                >
                <span
                  v-else-if="
                    parseInt(match.fullSGA.sgaEmployeeInfo.roleContract) ===
                      TypeOfRoleContract.partTime
                  "
                  class="permanent-role-type"
                >
                  PartTime</span
                >
                <span v-else class="temporary-role-type"> Not Set</span>
              </el-col>
              <el-col :lg="3" :xl="2" :sm="12" :xs="12">
                <span class="permanent-role-type"> {{ match.postAge }}</span>
              </el-col>
            </el-row>
            <!-- Accordion Certificate & Education -->
            <div style="padding: 30px">
              <el-collapse class="matching">
                <!-- Education -->
                <el-collapse-item name="1">
                  <template slot="title">
                    Education
                    <el-tooltip
                      class="item"
                      effect="dark"
                      style="padding-left: 5px"
                      placement="top"
                    >
                      <div slot="content">
                        <span style="font-weight: bold"
                          >Education Color Codes.</span
                        ><br /><br />
                        <span style="color: #fb2e01">Red </span> - Education
                        that the candidate does not have. <br />
                        <span style="color: #6fcb9f">Green </span> - Education
                        that matched the requirement. <br />
                        <span style="color: #ccd2dd">Gray </span> - Education of
                        the candidate but not in the requirement. <br />
                      </div>
                      <i class="fa fa-info-circle" aria-hidden="true"></i>
                    </el-tooltip>
                  </template>
                  <el-tabs
                    type="border-card"
                    stretch
                    style="background-color: #ecfbfc"
                  >
                    <el-tab-pane label="Required">
                      <el-row :gutter="24">
                        <div class="required-container" style="padding: 40px">
                          <!-- RequiredEducation has value -->
                          <div v-if="match.requiredHasValue">
                            <div
                              v-for="(reqEducation,
                              index) in match.requiredEducation"
                              :key="index"
                            >
                              <!-- Secondary Level -->
                              <div
                                v-if="
                                  (index === 'SecondLevel' &&
                                    reqEducation.oLevel) ||
                                    reqEducation.aLevel
                                "
                              >
                                <el-col
                                  :xl="12"
                                  :lg="12"
                                  :md="12"
                                  :sm="24"
                                  :xs="24"
                                  class="block-container"
                                  style="padding: 10px; height: 245px"
                                >
                                  <span
                                    style="font-weight: bold; font-size: 15px"
                                  >
                                    Secondary Level Education</span
                                  >
                                  <div class="educ-in-border">
                                    <!-- HighSchool Diploma -->
                                    <div
                                      v-if="reqEducation.hsd"
                                      style="padding-bottom: 1px"
                                    >
                                      <span
                                        v-if="reqEducation.reqHsd"
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                          color: #6fcb9f;
                                        "
                                      >
                                        High School Diploma</span
                                      >
                                      <span
                                        v-else
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                          color: #fb2e01;
                                        "
                                      >
                                        High School Diploma</span
                                      >
                                    </div>
                                    <div
                                      v-if="
                                        !reqEducation.hsd && reqEducation.reqHsd
                                      "
                                      style="padding-bottom: 1px"
                                    >
                                      <span
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                          color: #ccd2dd;
                                        "
                                      >
                                        High School Diploma</span
                                      >
                                    </div>

                                    <!-- General Equivalent Diploma -->
                                    <div
                                      v-if="reqEducation.ged"
                                      style="padding-bottom: 1px"
                                    >
                                      <span
                                        v-if="reqEducation.reqGed"
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                          color: #6fcb9f;
                                        "
                                      >
                                        General Equivalent Diploma</span
                                      >
                                      <span
                                        v-else
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                          color: #fb2e01;
                                        "
                                      >
                                        General Equivalent Diploma</span
                                      >
                                    </div>
                                    <div
                                      v-if="
                                        !reqEducation.ged && reqEducation.reqGed
                                      "
                                      style="padding-bottom: 1px"
                                    >
                                      <span
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                          color: #ccd2dd;
                                        "
                                      >
                                        General Equivalent Diploma</span
                                      >
                                    </div>

                                    <!-- Leaving Certificate -->
                                    <div
                                      v-if="reqEducation.leavingCert"
                                      style="padding-bottom: 1px"
                                    >
                                      <span
                                        v-if="reqEducation.reqLeavingCert"
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                          color: #6fcb9f;
                                        "
                                      >
                                        Leaving Certificate</span
                                      >
                                      <span
                                        v-else
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                          color: #fb2e01;
                                        "
                                      >
                                        Leaving Certificate</span
                                      >
                                    </div>
                                    <div
                                      v-if="
                                        !reqEducation.leavingCert &&
                                          reqEducation.reqLeavingCert
                                      "
                                      style="padding-bottom: 1px"
                                    >
                                      <span
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                          color: #ccd2dd;
                                        "
                                      >
                                        Leaving Certificate</span
                                      >
                                    </div>

                                    <!-- O-Level -->
                                    <div
                                      v-if="reqEducation.oLevel"
                                      style="padding-bottom: 1px"
                                    >
                                      <span
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                        "
                                      >
                                        O-Levels
                                      </span>
                                      <div>
                                        <span
                                          v-for="(olevel,
                                          index) in reqEducation.oLevel"
                                          :key="index"
                                        >
                                          <span
                                            v-if="olevel.value == 'Required'"
                                            style="color: #fb2e01"
                                          >
                                            {{ olevel.selection }} -
                                            {{ olevel.grade }}
                                          </span>
                                          <span
                                            v-if="olevel.value == 'Matched'"
                                            style="color: #6fcb9f"
                                          >
                                            {{ olevel.selection }} -
                                            {{ olevel.grade }}
                                          </span>
                                          <span
                                            v-if="olevel.value == 'Plus'"
                                            style="color: #ccd2dd"
                                          >
                                            {{ olevel.selection }} -
                                            {{ olevel.grade }}
                                          </span>
                                          <span
                                            v-if="
                                              reqEducation.oLevel.length - 1 !=
                                                index
                                            "
                                            >,
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                    <!-- A-Level -->
                                    <div
                                      v-if="reqEducation.aLevel"
                                      style="padding-bottom: 1px"
                                    >
                                      <span
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                        "
                                      >
                                        A-Levels
                                      </span>
                                      <div>
                                        <span
                                          v-for="(alevel,
                                          index) in reqEducation.aLevel"
                                          :key="index"
                                        >
                                          <span
                                            v-if="alevel.value == 'Required'"
                                            style="color: #fb2e01"
                                          >
                                            {{ alevel.selection }} -
                                            {{ alevel.grade }}
                                          </span>
                                          <span
                                            v-if="alevel.value == 'Matched'"
                                            style="color: #6fcb9f"
                                          >
                                            {{ alevel.selection }} -
                                            {{ alevel.grade }}
                                          </span>
                                          <span
                                            v-if="alevel.value == 'Plus'"
                                            style="color: #ccd2dd"
                                          >
                                            {{ alevel.selection }} -
                                            {{ alevel.grade }}
                                          </span>
                                          <span
                                            v-if="
                                              reqEducation.aLevel.length - 1 !=
                                                index
                                            "
                                            >,
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </el-col>
                              </div>

                              <!-- Third Level -->
                              <div
                                v-if="
                                  (index === 'ThirdLevel' &&
                                    reqEducation.associateDegree) ||
                                    reqEducation.bachelorsDegree
                                "
                              >
                                <el-col
                                  :xl="12"
                                  :lg="12"
                                  :md="12"
                                  :sm="24"
                                  :xs="24"
                                  class="block-container"
                                  style="padding: 10px; height: 245px"
                                >
                                  <span
                                    style="font-weight: bold; font-size: 15px"
                                  >
                                    Third Level Education</span
                                  >
                                  <div class="educ-in-border">
                                    <!-- AssociateDegree -->
                                    <div
                                      v-if="reqEducation.associateDegree"
                                      style="padding-bottom: 10px"
                                    >
                                      <span
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                        "
                                      >
                                        Associate Degree
                                      </span>
                                      <div>
                                        <span
                                          v-for="(aDegree,
                                          index) in reqEducation.associateDegree"
                                          :key="index"
                                        >
                                          <span
                                            v-if="aDegree.value == 'Required'"
                                            style="color: #fb2e01"
                                          >
                                            {{ aDegree.selection }}
                                          </span>
                                          <span
                                            v-if="aDegree.value == 'Matched'"
                                            style="color: #6fcb9f"
                                          >
                                            {{ aDegree.selection }}
                                          </span>
                                          <span
                                            v-if="aDegree.value == 'Plus'"
                                            style="color: #ccd2dd"
                                          >
                                            {{ aDegree.selection }}
                                          </span>
                                          <span
                                            v-if="
                                              reqEducation.associateDegree
                                                .length -
                                                1 !=
                                                index
                                            "
                                            >,
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                    <!-- BachelorsDegree -->
                                    <div
                                      v-if="reqEducation.bachelorsDegree"
                                      style="padding-bottom: 10px"
                                    >
                                      <span
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                        "
                                      >
                                        Bachelors Degree
                                      </span>
                                      <div>
                                        <span
                                          v-for="(bDegree,
                                          index) in reqEducation.bachelorsDegree"
                                          :key="index"
                                        >
                                          <span
                                            v-if="bDegree.value == 'Required'"
                                            style="color: #fb2e01"
                                          >
                                            {{ bDegree.selection }}
                                          </span>
                                          <span
                                            v-if="bDegree.value == 'Matched'"
                                            style="color: #6fcb9f"
                                          >
                                            {{ bDegree.selection }}
                                          </span>
                                          <span
                                            v-if="bDegree.value == 'Plus'"
                                            style="color: #ccd2dd"
                                          >
                                            {{ bDegree.selection }}
                                          </span>
                                          <span
                                            v-if="
                                              reqEducation.bachelorsDegree
                                                .length -
                                                1 !=
                                                index
                                            "
                                            >,
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </el-col>
                              </div>

                              <!-- Fourth Level -->
                              <div
                                v-if="
                                  (index === 'FourthLevel' &&
                                    reqEducation.mastersDegree) ||
                                    reqEducation.doctoralDegree
                                "
                              >
                                <el-col
                                  :xl="12"
                                  :lg="12"
                                  :md="12"
                                  :sm="24"
                                  :xs="24"
                                  class="block-container"
                                  style="padding: 10px; height: 245px"
                                >
                                  <span
                                    style="font-weight: bold; font-size: 15px"
                                  >
                                    Fourth Level Education</span
                                  >
                                  <div class="educ-in-border">
                                    <!-- MastersDegree -->
                                    <div
                                      v-if="reqEducation.mastersDegree"
                                      style="padding-bottom: 10px"
                                    >
                                      <span
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                        "
                                      >
                                        Masters Degree
                                      </span>
                                      <div>
                                        <span
                                          v-for="(mDegree,
                                          index) in reqEducation.mastersDegree"
                                          :key="index"
                                        >
                                          <span
                                            v-if="mDegree.value == 'Required'"
                                            style="color: #fb2e01"
                                          >
                                            {{ mDegree.selection }}
                                          </span>
                                          <span
                                            v-if="mDegree.value == 'Matched'"
                                            style="color: #6fcb9f"
                                          >
                                            {{ mDegree.selection }}
                                          </span>
                                          <span
                                            v-if="mDegree.value == 'Plus'"
                                            style="color: #ccd2dd"
                                          >
                                            {{ mDegree.selection }}
                                          </span>
                                          <span
                                            v-if="
                                              reqEducation.mastersDegree
                                                .length -
                                                1 !=
                                                index
                                            "
                                            >,
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                    <!-- DoctoralDegree -->
                                    <div
                                      v-if="reqEducation.doctoralDegree"
                                      style="padding-bottom: 10px"
                                    >
                                      <span
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                        "
                                      >
                                        Doctoral Degree
                                      </span>
                                      <div>
                                        <span
                                          v-for="(dDegree,
                                          index) in reqEducation.doctoralDegree"
                                          :key="index"
                                        >
                                          <span
                                            v-if="dDegree.value == 'Required'"
                                            style="color: #fb2e01"
                                          >
                                            {{ dDegree.selection }}
                                          </span>
                                          <span
                                            v-if="dDegree.value == 'Matched'"
                                            style="color: #6fcb9f"
                                          >
                                            {{ dDegree.selection }}
                                          </span>
                                          <span
                                            v-if="dDegree.value == 'Plus'"
                                            style="color: #ccd2dd"
                                          >
                                            {{ dDegree.selection }}
                                          </span>
                                          <span
                                            v-if="
                                              reqEducation.doctoralDegree
                                                .length -
                                                1 !=
                                                index
                                            "
                                            >,
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </el-col>
                              </div>

                              <!-- Sector Experience -->
                              <div
                                v-if="
                                  index === 'SectorExperience' &&
                                    reqEducation.experience
                                "
                              >
                                <el-col
                                  :xl="12"
                                  :lg="12"
                                  :md="12"
                                  :sm="24"
                                  :xs="24"
                                  class="block-container"
                                  style="padding: 10px; height: 245px"
                                >
                                  <span
                                    style="font-weight: bold; font-size: 15px"
                                  >
                                    Sector Experience</span
                                  >
                                  <div class="educ-in-border">
                                    <!-- Experience -->
                                    <div
                                      v-if="reqEducation.experience"
                                      style="padding-bottom: 10px"
                                    >
                                      <div
                                        v-for="(exp,
                                        index) in reqEducation.experience"
                                        :key="index"
                                      >
                                        <span v-if="exp.value == 'Required'"
                                          ><span
                                            style="
                                              font-weight: bold;
                                              font-size: 14px;
                                              color: #fb2e01;
                                            "
                                          >
                                            {{
                                              findSector(exp.selection)
                                            }}</span
                                          >
                                          - {{ exp.yearsOfExperience }}
                                        </span>
                                        <span v-if="exp.value == 'Matched'"
                                          ><span
                                            style="
                                              font-weight: bold;
                                              font-size: 14px;
                                              color: #6fcb9f;
                                            "
                                          >
                                            {{
                                              findSector(exp.selection)
                                            }}</span
                                          >
                                          - {{ exp.yearsOfExperience }}
                                        </span>
                                        <span v-if="exp.value == 'Plus'"
                                          ><span
                                            style="
                                              font-weight: bold;
                                              font-size: 14px;
                                              color: #ccd2dd;
                                            "
                                          >
                                            {{
                                              findSector(exp.selection)
                                            }}</span
                                          >
                                          - {{ exp.yearsOfExperience }}
                                        </span>
                                        <span
                                          v-if="
                                            reqEducation.experience.length -
                                              1 !=
                                              index
                                          "
                                          >,
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </el-col>
                              </div>
                            </div>
                          </div>

                          <div v-else>No Required Education Information.</div>
                        </div>
                      </el-row>
                    </el-tab-pane>
                    <el-tab-pane label="Desired">
                      <el-row :gutter="24">
                        <div class="desired-container" style="padding: 40px">
                          <!-- RequiredEducation has value -->
                          <div v-if="match.desiredHasValue">
                            <div
                              v-for="(desEducation,
                              index) in match.desiredEducation"
                              :key="index"
                            >
                              <!-- Secondary Level -->
                              <div
                                v-if="
                                  (index === 'SecondLevel' &&
                                    desEducation.oLevel) ||
                                    desEducation.aLevel
                                "
                              >
                                <el-col
                                  :xl="12"
                                  :lg="12"
                                  :md="12"
                                  :sm="24"
                                  :xs="24"
                                  class="block-container"
                                  style="padding: 10px; height: 245px"
                                >
                                  <span
                                    style="font-weight: bold; font-size: 15px"
                                  >
                                    Secondary Level Education</span
                                  >
                                  <div class="educ-in-border">
                                    <!-- HighSchool Diploma -->
                                    <div
                                      v-if="desEducation.hsd"
                                      style="padding-bottom: 1px"
                                    >
                                      <span
                                        v-if="desEducation.reqHsd"
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                          color: #6fcb9f;
                                        "
                                      >
                                        High School Diploma</span
                                      >
                                      <span
                                        v-else
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                          color: #fb2e01;
                                        "
                                      >
                                        High School Diploma</span
                                      >
                                    </div>
                                    <div
                                      v-if="
                                        !desEducation.hsd && desEducation.reqHsd
                                      "
                                      style="padding-bottom: 1px"
                                    >
                                      <span
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                          color: #ccd2dd;
                                        "
                                      >
                                        High School Diploma</span
                                      >
                                    </div>

                                    <!-- General Equivalent Diploma -->
                                    <div
                                      v-if="desEducation.ged"
                                      style="padding-bottom: 1px"
                                    >
                                      <span
                                        v-if="desEducation.reqGed"
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                          color: #6fcb9f;
                                        "
                                      >
                                        General Equivalent Diploma</span
                                      >
                                      <span
                                        v-else
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                          color: #fb2e01;
                                        "
                                      >
                                        General Equivalent Diploma</span
                                      >
                                    </div>
                                    <div
                                      v-if="
                                        !desEducation.ged && desEducation.reqGed
                                      "
                                      style="padding-bottom: 1px"
                                    >
                                      <span
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                          color: #ccd2dd;
                                        "
                                      >
                                        General Equivalent Diploma</span
                                      >
                                    </div>

                                    <!-- Leaving Certificate -->
                                    <div
                                      v-if="desEducation.leavingCert"
                                      style="padding-bottom: 1px"
                                    >
                                      <span
                                        v-if="desEducation.reqLeavingCert"
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                          color: #6fcb9f;
                                        "
                                      >
                                        Leaving Certificate</span
                                      >
                                      <span
                                        v-else
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                          color: #fb2e01;
                                        "
                                      >
                                        Leaving Certificate</span
                                      >
                                    </div>
                                    <div
                                      v-if="
                                        !desEducation.leavingCert &&
                                          desEducation.reqLeavingCert
                                      "
                                      style="padding-bottom: 1px"
                                    >
                                      <span
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                          color: #ccd2dd;
                                        "
                                      >
                                        Leaving Certificate</span
                                      >
                                    </div>

                                    <!-- O-Level -->
                                    <div
                                      v-if="desEducation.oLevel"
                                      style="padding-bottom: 1px"
                                    >
                                      <span
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                        "
                                      >
                                        O-Levels
                                      </span>
                                      <div>
                                        <span
                                          v-for="(olevel,
                                          index) in desEducation.oLevel"
                                          :key="index"
                                        >
                                          <span
                                            v-if="olevel.value == 'Required'"
                                            style="color: #fb2e01"
                                          >
                                            {{ olevel.selection }} -
                                            {{ olevel.grade }}
                                          </span>
                                          <span
                                            v-if="olevel.value == 'Matched'"
                                            style="color: #6fcb9f"
                                          >
                                            {{ olevel.selection }} -
                                            {{ olevel.grade }}
                                          </span>
                                          <span
                                            v-if="olevel.value == 'Plus'"
                                            style="color: #ccd2dd"
                                          >
                                            {{ olevel.selection }} -
                                            {{ olevel.grade }}
                                          </span>
                                          <span
                                            v-if="
                                              desEducation.oLevel.length - 1 !=
                                                index
                                            "
                                            >,
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                    <!-- A-Level -->
                                    <div
                                      v-if="desEducation.aLevel"
                                      style="padding-bottom: 1px"
                                    >
                                      <span
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                        "
                                      >
                                        A-Levels
                                      </span>
                                      <div>
                                        <span
                                          v-for="(alevel,
                                          index) in desEducation.aLevel"
                                          :key="index"
                                        >
                                          <span
                                            v-if="alevel.value == 'Required'"
                                            style="color: #fb2e01"
                                          >
                                            {{ alevel.selection }} -
                                            {{ alevel.grade }}
                                          </span>
                                          <span
                                            v-if="alevel.value == 'Matched'"
                                            style="color: #6fcb9f"
                                          >
                                            {{ alevel.selection }} -
                                            {{ alevel.grade }}
                                          </span>
                                          <span
                                            v-if="alevel.value == 'Plus'"
                                            style="color: #ccd2dd"
                                          >
                                            {{ alevel.selection }} -
                                            {{ alevel.grade }}
                                          </span>
                                          <span
                                            v-if="
                                              desEducation.aLevel.length - 1 !=
                                                index
                                            "
                                            >,
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </el-col>
                              </div>

                              <!-- Third Level -->
                              <div
                                v-if="
                                  (index === 'ThirdLevel' &&
                                    desEducation.associateDegree) ||
                                    desEducation.bachelorsDegree
                                "
                              >
                                <el-col
                                  :xl="12"
                                  :lg="12"
                                  :md="12"
                                  :sm="24"
                                  :xs="24"
                                  class="block-container"
                                  style="padding: 10px; height: 245px"
                                >
                                  <span
                                    style="font-weight: bold; font-size: 15px"
                                  >
                                    Third Level Education</span
                                  >
                                  <div class="educ-in-border">
                                    <!-- AssociateDegree -->
                                    <div
                                      v-if="desEducation.associateDegree"
                                      style="padding-bottom: 10px"
                                    >
                                      <span
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                        "
                                      >
                                        Associate Degree
                                      </span>
                                      <div>
                                        <span
                                          v-for="(aDegree,
                                          index) in desEducation.associateDegree"
                                          :key="index"
                                        >
                                          <span
                                            v-if="aDegree.value == 'Required'"
                                            style="color: #fb2e01"
                                          >
                                            {{ aDegree.selection }}
                                          </span>
                                          <span
                                            v-if="aDegree.value == 'Matched'"
                                            style="color: #6fcb9f"
                                          >
                                            {{ aDegree.selection }}
                                          </span>
                                          <span
                                            v-if="aDegree.value == 'Plus'"
                                            style="color: #ccd2dd"
                                          >
                                            {{ aDegree.selection }}
                                          </span>
                                          <span
                                            v-if="
                                              desEducation.associateDegree
                                                .length -
                                                1 !=
                                                index
                                            "
                                            >,
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                    <!-- BachelorsDegree -->
                                    <div
                                      v-if="desEducation.bachelorsDegree"
                                      style="padding-bottom: 10px"
                                    >
                                      <span
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                        "
                                      >
                                        Bachelors Degree
                                      </span>
                                      <div>
                                        <span
                                          v-for="(bDegree,
                                          index) in desEducation.bachelorsDegree"
                                          :key="index"
                                        >
                                          <span
                                            v-if="bDegree.value == 'Required'"
                                            style="color: #fb2e01"
                                          >
                                            {{ bDegree.selection }}
                                          </span>
                                          <span
                                            v-if="bDegree.value == 'Matched'"
                                            style="color: #6fcb9f"
                                          >
                                            {{ bDegree.selection }}
                                          </span>
                                          <span
                                            v-if="bDegree.value == 'Plus'"
                                            style="color: #ccd2dd"
                                          >
                                            {{ bDegree.selection }}
                                          </span>
                                          <span
                                            v-if="
                                              desEducation.bachelorsDegree
                                                .length -
                                                1 !=
                                                index
                                            "
                                            >,
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </el-col>
                              </div>

                              <!-- Fourth Level -->
                              <div
                                v-if="
                                  (index === 'FourthLevel' &&
                                    desEducation.mastersDegree) ||
                                    desEducation.doctoralDegree
                                "
                              >
                                <el-col
                                  :xl="12"
                                  :lg="12"
                                  :md="12"
                                  :sm="24"
                                  :xs="24"
                                  class="block-container"
                                  style="padding: 10px; height: 245px"
                                >
                                  <span
                                    style="font-weight: bold; font-size: 15px"
                                  >
                                    Fourth Level Education</span
                                  >
                                  <div class="educ-in-border">
                                    <!-- MastersDegree -->
                                    <div
                                      v-if="desEducation.mastersDegree"
                                      style="padding-bottom: 10px"
                                    >
                                      <span
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                        "
                                      >
                                        Masters Degree
                                      </span>
                                      <div>
                                        <span
                                          v-for="(mDegree,
                                          index) in desEducation.mastersDegree"
                                          :key="index"
                                        >
                                          <span
                                            v-if="mDegree.value == 'Required'"
                                            style="color: #fb2e01"
                                          >
                                            {{ mDegree.selection }}
                                          </span>
                                          <span
                                            v-if="mDegree.value == 'Matched'"
                                            style="color: #6fcb9f"
                                          >
                                            {{ mDegree.selection }}
                                          </span>
                                          <span
                                            v-if="mDegree.value == 'Plus'"
                                            style="color: #ccd2dd"
                                          >
                                            {{ mDegree.selection }}
                                          </span>
                                          <span
                                            v-if="
                                              desEducation.mastersDegree
                                                .length -
                                                1 !=
                                                index
                                            "
                                            >,
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                    <!-- DoctoralDegree -->
                                    <div
                                      v-if="desEducation.doctoralDegree"
                                      style="padding-bottom: 10px"
                                    >
                                      <span
                                        style="
                                          font-weight: bold;
                                          font-size: 14px;
                                        "
                                      >
                                        Doctoral Degree
                                      </span>
                                      <div>
                                        <span
                                          v-for="(dDegree,
                                          index) in desEducation.doctoralDegree"
                                          :key="index"
                                        >
                                          <span
                                            v-if="dDegree.value == 'Required'"
                                            style="color: #fb2e01"
                                          >
                                            {{ dDegree.selection }}
                                          </span>
                                          <span
                                            v-if="dDegree.value == 'Matched'"
                                            style="color: #6fcb9f"
                                          >
                                            {{ dDegree.selection }}
                                          </span>
                                          <span
                                            v-if="dDegree.value == 'Plus'"
                                            style="color: #ccd2dd"
                                          >
                                            {{ dDegree.selection }}
                                          </span>
                                          <span
                                            v-if="
                                              desEducation.doctoralDegree
                                                .length -
                                                1 !=
                                                index
                                            "
                                            >,
                                          </span>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </el-col>
                              </div>

                              <!-- Sector Experience -->
                              <div
                                v-if="
                                  index === 'SectorExperience' &&
                                    desEducation.experience
                                "
                              >
                                <el-col
                                  :xl="12"
                                  :lg="12"
                                  :md="12"
                                  :sm="24"
                                  :xs="24"
                                  class="block-container"
                                  style="padding: 10px; height: 245px"
                                >
                                  <span
                                    style="font-weight: bold; font-size: 15px"
                                  >
                                    Sector Experience</span
                                  >
                                  <div class="educ-in-border">
                                    <!-- Experience -->
                                    <div
                                      v-if="desEducation.experience"
                                      style="padding-bottom: 10px"
                                    >
                                      <div
                                        v-for="(exp,
                                        index) in desEducation.experience"
                                        :key="index"
                                      >
                                        <span v-if="exp.value == 'Required'"
                                          ><span
                                            style="
                                              font-weight: bold;
                                              font-size: 14px;
                                              color: #fb2e01;
                                            "
                                          >
                                            {{
                                              findSector(exp.selection)
                                            }}</span
                                          >
                                          - {{ exp.yearsOfExperience }}
                                        </span>
                                        <span v-if="exp.value == 'Matched'"
                                          ><span
                                            style="
                                              font-weight: bold;
                                              font-size: 14px;
                                              color: #6fcb9f;
                                            "
                                          >
                                            {{
                                              findSector(exp.selection)
                                            }}</span
                                          >
                                          - {{ exp.yearsOfExperience }}
                                        </span>
                                        <span v-if="exp.value == 'Plus'"
                                          ><span
                                            style="
                                              font-weight: bold;
                                              font-size: 14px;
                                              color: #ccd2dd;
                                            "
                                          >
                                            {{
                                              findSector(exp.selection)
                                            }}</span
                                          >
                                          - {{ exp.yearsOfExperience }}
                                        </span>
                                        <span
                                          v-if="
                                            desEducation.experience.length -
                                              1 !=
                                              index
                                          "
                                          >,
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </el-col>
                              </div>
                            </div>
                          </div>

                          <div v-else>No Desired Education Information.</div>
                        </div>
                      </el-row>
                    </el-tab-pane>
                  </el-tabs>
                </el-collapse-item>
                <!-- Certificate -->
                <el-collapse-item name="2">
                  <template slot="title">
                    Certifications
                    <el-tooltip
                      class="item"
                      effect="dark"
                      style="padding-left: 5px"
                      placement="top"
                    >
                      <div slot="content">
                        <span style="font-weight: bold"
                          >Certifications Color Codes.</span
                        ><br /><br />
                        <span style="color: #fb2e01">Red </span> - Required
                        certificates that the candidate does not have. <br />
                        <span style="color: #6fcb9f">Green </span> -
                        Certificates that matched the requirement. <br />
                        <span style="color: #ffd936">Yellow </span> - Desired
                        certificates that the candidate does not have. <br />
                        <span style="color: #ccd2dd">Gray </span> - Certificates
                        of the candidate but not in the requirement. <br />
                        Press the "View" button to view the certificate.
                      </div>
                      <i class="fa fa-info-circle" aria-hidden="true"></i>
                    </el-tooltip>
                  </template>
                  <div
                    v-for="(certificates, index) in match.evalCertificates"
                    :key="index"
                    style="padding: 5px"
                  >
                    <div class="cert-border">
                      <el-row :gutter="24">
                        <el-col>
                          <span
                            v-if="certificates.value === 'Required'"
                            style="
                              padding-left: 5px;
                              color: #fb2e01;
                              font-size: 14px;
                            "
                          >
                            {{ findCertificate(certificates.selection) }}</span
                          >
                          <span
                            v-else-if="certificates.value === 'Desired'"
                            style="
                              padding-left: 5px;
                              color: #ffd936;
                              font-size: 14px;
                            "
                          >
                            {{ findCertificate(certificates.selection) }}</span
                          >
                          <span
                            v-else-if="certificates.value === 'Matched'"
                            style="
                              padding-left: 5px;
                              color: #6fcb9f;
                              font-size: 14px;
                            "
                          >
                            {{ findCertificate(certificates.selection) }}</span
                          >
                          <span
                            v-else
                            style="
                              padding-left: 5px;
                              color: #ccd2dd;
                              font-size: 14px;
                            "
                          >
                            {{ findCertificate(certificates.selection) }}</span
                          >
                        </el-col>
                      </el-row>
                      <el-row :gutter="24" v-if="certificates.value === 'Matched' || certificates.value === 'Plus'">
                        <el-col
                          :span="20"
                          v-if="
                            new Date(certificates.expiryDate).toLocaleDateString(
                              'en-US',
                              options
                            ) !== 'Invalid Date'
                          "
                        >
                          <div
                            v-if="
                              new Date(
                                certificates.expiryDate
                              ).toLocaleDateString('en-US', options) !==
                              'January 1, 2001'
                            "
                          >
                            <span style="padding-left: 5px; color: #ccd2dd"
                              >Expiry Date:</span
                            >
                            <span style="font-weight: bold">
                              {{
                                new Date(
                                  certificates.expiryDate
                                ).toLocaleDateString("en-US", options)
                              }}</span
                            >
                            <span
                              v-if="checkExpiryDate(certificates.expiryDate)"
                              style="padding-left: 5px"
                            >
                              <el-tag size="mini" type="danger">Expired</el-tag>
                            </span>
                          </div>
                          <div v-else>
                            <span style="padding-left: 5px; color: #ccd2dd"
                              >Expiry Date:
                            </span>
                            <span style="font-weight: bold"> No Expiry Date</span>
                          </div>
                        </el-col>
                        <el-col :span="20" v-else>
                          <span style="padding-left: 5px; color: #ccd2dd"
                            >Expiry Date:
                          </span>
                          <span style="font-weight: bold"> No Expiry Date</span>
                        </el-col>
                      </el-row>
                    </div>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
          <div style="text-align: center; padding: 5px">
            <el-button
              v-if="!isLastItem"
              @click="loadMore"
              style="width: 100%; background-color: #00c8dc; color: white"
              >Load More</el-button
            >
            <el-button v-else @click="loadMore" style="width: 100%" disabled
              >Load More</el-button
            >
          </div>
        </div>
        <div v-if="matches == 0" :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
          <el-alert
            :closable="false"
            :title="noDataText"
            type="error"
          ></el-alert>
          <div :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
            <div class="no-data">
              <span class="fa-stack">
                <i class="fas fa-circle fa-stack-2x"></i>
                <i class="far fa-folder-open fa-stack-1x fa-inverse"></i>
              </span>
            </div>
          </div>
        </div>
      </el-row>
      <!-- <loading 
            :active.sync="loading"
            :can-cancel="false"
            :is-full-page="false">
        </loading> -->

      <TSLoading
        :active="loading"
        :defaultMessage="'Please wait...'"
        :altMessage="'Please hold on for a moment while we process the data...'"
      />
    </div>

    <el-dialog
      title="Apply for Job Role"
      :visible="showModal"
      :show-close="false"
      width="580px"
      class="ts-modal"
    >
      <p>
        By applying for this role posted by {{ matchInfo.companyName }}, you are
        agreeing to your contact details to be visible so that the company may
        contact you in regards to the role and interview process.
      </p>
      &nbsp;&nbsp;
      <el-row :gutter="10">
        <el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="12">
          <button
            class="ts-btn ts-btn-small"
            style="float: right"
            @click="confirmApplyForRole"
          >
            Apply for Role
          </button>
        </el-col>
        <el-col :xl="12" :lg="12" :md="12" :sm="12" :xs="12">
          <button
            class="ts-btn ts-btn-small ts-btn-white"
            style="float: left"
            @click="onCloseDialog(null)"
          >
            Cancel
          </button>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import * as signalR from "@aspnet/signalr";

import { TypeOfRoleContract } from "@/enums";
import TSLoading from "../../../components/TSLoading.vue";

export default {
  created() {
    // //create signalR connection
    // this.huburl = process.env.VUE_APP_MESSAGE_BASE_URI;
    // this.connection = new signalR.HubConnectionBuilder()
    //   .withUrl(this.huburl, {
    //     transport:
    //       signalR.HttpTransportType.WebSockets |
    //       signalR.HttpTransportType.LongPolling,
    //     "content-type": "application/json",
    //     accessTokenFactory: () => localStorage.getItem("token"),
    //   })
    //   .build();

    // this.connection.start().catch(function (err) {
    //   return console.error(err.toString());
    // });

    //check localstorage searchresults variable
    if (JSON.parse(sessionStorage.getItem("searchResultsSession")) != null) {
      this.searchResultsSession = JSON.parse(
        sessionStorage.getItem("searchResultsSession")
      );
      this.pageCount = this.searchResultsSession.pageCount;
      this.matches = this.searchResultsSession.matches;
      this.keyword = this.searchResultsSession.keyword;
      this.searchtype = this.searchResultsSession.searchtype;
      this.certificateOptions = this.searchResultsSession.certificateOptions;
    }
  },
  components: {
    TSLoading
  },
  data() {
    return {
      connection: "",
      huburl: "",
      keyword: null,
      searchtype: "Jobs",
      searchPlaceholder: "Search for Jobs",
      searchlist: ["Jobs", "Company"],
      matches: [],
      noDataText: "",
      pageCount: 1,
      isLastItem: false,
      matchResults: [],
      matchedCount: null,
      countTemp: 0,
      areMatchesLoading: false,
      loading: false,
      TypeOfRoleContract,
      sectorOptions: [],
      showModal: false,
      matchInfo: {},
      applybutton: null,
      searchResultsSession: {},
      options: { year: "numeric", month: "long", day: "numeric" },
    };
  },
  watch: {
    searchtype() {
      this.searchPlaceholder =
        this.searchtype == "Jobs" ? "Search for Jobs" : "Search for Company";
    }
  },
  computed: {
    currentJobSeeker() {
      return this.$store.state.account.current_user;
    }
  },
  beforeDestroy() {
    if (this.$router.history.current.name != "role-posting") {
      sessionStorage.setItem("searchResultsSession", null);
    }
  },
  mounted() {},
  methods: {
    backToOrigin() {
      this.$router.push({ name: "jobseeker-dashboard" });
    },
    search() {
      this.pageCount = 1;
      this.loading = true;
      this.areMatchesLoading = true;
      this.noDataText = "Retrieving matches...";

      var userId = null;
      if (this.$store.state.account.applicant_user_info.skillProfileCompleted) {
        userId = this.currentJobSeeker.id;
      }

      this.$store
        .dispatch("jobseeker/searchjob", {
          userId: userId,
          weighting: 0,
          distance: "250",
          certificate: "",
          pageCount: this.pageCount,
          keyword: this.keyword,
          searchtype: this.searchtype
        })
        .then(res => {
          this.matches = res.candidates;
          this.pageCount = res.pageCount;
          this.isLastItem = res.isLastItem;
          this.matchResults = this.matches;
          this.matchedCount = this.matches.length;
          this.countTemp = this.matchedCount;
          this.areMatchesLoading = false;
          this.loading = false;
          this.noDataText = "There are no current job matches";
        });

      this.$store
        .dispatch(
          "organisation/getAllReferencesByReferenceTypeCategory",
          "Certificate"
        )
        .then(res => {
          this.certificateOptions = res.sort(function(a, b) {
            return ("" + a.description).localeCompare(b.description);
          });
        });

      this.$store.dispatch("onet/getsectors").then(res => {
        this.sectorOptions = res;
      });

      // axios
      //   .get(`${process.env.VUE_APP_API_BASE_URI}onet/getcertificates`)
      //   .then((res) => {
      //     this.certificateOptions = res.data
      //       .filter(
      //         (r) => r.codeHeaderId != "9c2f4cca-38a4-11eb-9a00-8c04ba629523"
      //       )
      //       .sort(function (a, b) {
      //         return ("" + a.description).localeCompare(b.description);
      //       });
      //   });

      // axios
      //   .get(`${process.env.VUE_APP_API_BASE_URI}onet/getsectors`)
      //   .then((res) => {
      //     this.sectorOptions = res.data;
      //   });
    },
    viewRole(match) {
      this.searchResultsSession.pageCount = this.pageCount;
      this.searchResultsSession.matches = this.matches;
      this.searchResultsSession.keyword = this.keyword;
      this.searchResultsSession.searchtype = this.searchtype;
      this.searchResultsSession.certificateOptions = this.certificateOptions;

      sessionStorage.setItem(
        "searchResultsSession",
        JSON.stringify(this.searchResultsSession)
      );

      this.$router.push({
        name: "role-posting",
        params: { vacantid: match.employeeId, matchdetail: match }
      });
    },
    applyForRole(match, e) {
      if (
        !this.$store.state.account.applicant_user_info.skillProfileCompleted
      ) {
        this.$confirm(
          `Please complete your SGA profile before applying for role.`,
          "Warning",
          {
            confirmButtonText: "OK",
            showCancelButton: false,
            type: "warning",
            dangerouslyUseHTMLString: true,
            center: true
          }
        ).then(() => {});
      } else {
        // this.$router.push({ name: 'ConfirmApplyForRoleDialog', params: { data: match }});
        this.matchInfo = match;
        this.showModal = true;
        // e.currentTarget.innerText = "* In progress!";
        // e.currentTarget.disabled = true
        this.applybutton = e.currentTarget;
      }
    },
    findSector(sectorCode) {
      var sector = this.sectorOptions.filter(e => e.code == sectorCode);
      if (sector.length != 0) {
        return sector[0].title;
      } else {
        return "N/A";
      }
    },
    findCertificate(certificateId) {
      var cert = this.certificateOptions.filter(function(el) { return el.id == certificateId } );
      return cert[0] != null ? cert[0].description : "";
    },
    loadMore() {
      this.pageCount = this.pageCount + 1;
      this.loading = true;
      this.areMatchesLoading = true;
      this.noDataText = "Retrieving matches...";

      var userId = null;
      if (this.$store.state.account.applicant_user_info.skillProfileCompleted) {
        userId = this.currentJobSeeker.id;
      }

      this.$store
        .dispatch("jobseeker/searchjob", {
          userId: userId,
          weighting: 0,
          distance: "250",
          certificate: "",
          pageCount: this.pageCount,
          keyword: this.keyword,
          searchtype: this.searchtype
        })
        .then(res => {
          // this.matches = res.VacantMatchList;
          res.candidates.forEach(data => {
            this.matches.push(data);
          });

          this.pageCount = res.pageCount;
          this.isLastItem = res.isLastItem;
          this.matchResults = this.matches;
          this.matchedCount = this.matches.length;
          this.countTemp = this.matchedCount;
          this.areMatchesLoading = false;
          this.loading = false;
          this.noDataText = "There are no current job matches";
        });
    },
    confirmApplyForRole() {
      var request = {
        EmployeeId: this.matchInfo.employeeId,
        UpSkillingRequired: this.matchInfo.sgaUpSkills,
        PercentMatch: this.matchInfo.percentMatch,
        Position: this.matchInfo.position,
        OrganisationId: this.matchInfo.fullSGA.sgaEmployeeInfo.organisationId,
        Payload: JSON.stringify(this.matchInfo.fullSGA)
      };
      this.$store.dispatch("jobseeker/applyForRole", request).then(res => {
        this.$message.success("Interest request has been sent to the company!");
        // this.$router.push({ name: 'role-matching' });
        this.onCloseDialog();
        this.applybutton.innerText = "* In progress!";
        this.applybutton.disabled = true;
      });
    },
    onCloseDialog() {
      this.matchInfo = {};
      this.showModal = false;
    },
    checkExpiryDate(expiryDate) {
      const certDate = new Date(expiryDate);
      const dateNow = new Date();
      return certDate <= dateNow;
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../assets/scss/project/rolematching.scss";

.mobile-menu .fa-reply {
  display: none !important;
}

@media screen and (max-width: 759px) {
  .mobile-menu .fa-reply {
    display: inherit !important;
  }

  .srch {
    margin: auto !important;
    width: 100% !important;
  }

  .srch-col {
    margin: 10px 0px 10px 0px !important;
  }

  .ts-matches--match_actions {
    display: none !important;
  }

  .required-container,
  .desired-container {
    padding: unset !important;
  }

  .block-container,
  .educ-in-border {
    height: unset !important;
  }

  .ts-matches--match_actions_mobile {
    display: unset !important;
  }

  .role-position-container-mid {
    width: 60% !important;
  }
}
</style>
